import { Link } from "react-router-dom";
import { t, type Locale } from "~/lib/i18n.ts";

export interface SiteFooterProps {
  locale: Locale;
}

export function SiteFooter({ locale }: SiteFooterProps) {
  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-card)] px-4 py-14 text-sm text-[var(--color-muted-foreground)] md:px-12 md:py-16">
      <div className="mx-auto grid max-w-6xl gap-10 md:grid-cols-4 md:gap-12">
        <div className="space-y-3 md:col-span-2">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="bg-brand grid h-8 w-8 place-items-center rounded-lg text-base font-extrabold text-[var(--color-brand-foreground)] shadow-[0_4px_16px_-4px_hsl(265_75%_50%/0.5)]">
              K
            </span>
            <span className="text-lg font-bold tracking-tight text-[var(--color-foreground)]">
              Krix
            </span>
          </Link>
          <p className="max-w-xs text-sm leading-relaxed">{t(locale, "footer.tagline")}</p>
          <p className="text-xs">
            <a
              href="mailto:hello@krix.sayantan.cloud"
              className="hover:text-[var(--color-foreground)]"
            >
              hello@krix.sayantan.cloud
            </a>
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[var(--color-foreground)]/80">
            Product
          </p>
          <nav className="flex flex-col gap-2 text-sm">
            <Link to="/pricing" className="hover:text-[var(--color-foreground)]">
              {t(locale, "footer.pricing")}
            </Link>
            <Link to="/browse" className="hover:text-[var(--color-foreground)]">
              {t(locale, "nav.browse")}
            </Link>
            <Link to="/about" className="hover:text-[var(--color-foreground)]">
              {t(locale, "footer.about")}
            </Link>
          </nav>
        </div>

        <div className="space-y-3">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[var(--color-foreground)]/80">
            Legal
          </p>
          <nav className="flex flex-col gap-2 text-sm">
            <Link to="/terms" className="hover:text-[var(--color-foreground)]">
              {t(locale, "footer.terms")}
            </Link>
            <Link to="/privacy" className="hover:text-[var(--color-foreground)]">
              {t(locale, "footer.privacy")}
            </Link>
            <Link to="/cookies" className="hover:text-[var(--color-foreground)]">
              {t(locale, "footer.cookies")}
            </Link>
          </nav>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-6xl border-t border-[var(--color-border)] pt-6 text-xs text-[var(--color-muted-foreground)]">
        © Krix. Watch carefully.
      </div>
    </footer>
  );
}
